import { Form, Formik } from 'formik'
import React from 'react'
import styled from 'styled-components'
import * as Yup from 'yup'
import Button from '../../../../../components/buttons/buttons.component'
import DatepickerInput from '../../../../../components/form-components/datepicker-input.component.jsx'
import StyledFlexContainer from './../../../../../components/containers/flex-container.component'
import {
	NumberInput,
	TextInput,
	CouponInput,
	SelectInput
} from '../../../../../components/form-components/inputs.component'
import { routes } from '../../../../../constants/routes.constants'
import { couponConstants } from './../../../../../constants/coupon-type.constants'
import { PRIMARY_LIGHT } from '../../../../../styles/colors.style'
import { breakpoints } from './../../../../../constants/breakpoints.constants'

const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding-top: 3.5rem;
`

const schema = Yup.object().shape({
	code: Yup.string().required('Informe o código do cupom'),
	description: Yup.string().required('Informe a descrição do cupom'),
	discountPercentage: Yup.number().required(
		'Informe a percentagem de desconto'
	),
	couponsAmount: Yup.number().moreThan(
		0,
		'A quantidade de cupons não pode ser 0'
	),
	couponsPerCustomer: Yup.number().required(
		'Informe a quantidade de resgates por cliente'
	),
	dateStart: Yup.date().required('Informe a data de início'),
	dateEnd: Yup.date().required('Informe a data de término'),
	couponType: Yup.string()
		.oneOf(couponConstants.couponTypeOptions.map(({ value }) => value))
		.required('Informe o tipo do cupom')
})

const initialValues = {
	code: '',
	description: '',
	discountPercentage: '',
	couponsAmount: '',
	couponsPerCustomer: '',
	moveflexNumber: '',
	dateStart: new Date(),
	dateEnd: new Date(),
	couponType: couponConstants.couponTypeOptions[0],
	paymentMethod: couponConstants.couponPaymentMethodOptions[0],
	busClasses: '',
	daysInAdvanceForBoarding: '',
	agencyFilter: couponConstants.couponAgencyOptions[0],
	salesOriginFilter: couponConstants.couponPlatformOptions[0]
}

class CreationForm extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			disablePartner: false
		}
	}
	changeAction = (props, state) => {
		props.setFieldValue('busCompany', '')
		this.setState({ disablePartner: state })
	}

	changeCouponType = (props, value) => {
		if (value === 'pointsPurchase') {
			props.setFieldValue('busCompany', '')
			this.setState({ disablePartner: true })
		} else {
			this.setState({ disablePartner: false })
		}
	}

	render() {
		const { onSubmit } = this.props
		return (
			<div>
				<Formik
					initialValues={initialValues}
					onSubmit={onSubmit}
					validationSchema={schema}
					render={props => (
						<Form className="form" noValidate>
							<StyledFlexContainer>
								<CouponInput
									className={'col-4'}
									id="code"
									label="Código do Cupom *"
									maxLength={16}
									autoFocus={true}
									{...props}
								/>
								<TextInput
									className={'col-8'}
									id="description"
									label="Descrição *"
									maxLength={256}
									{...props}
								/>
							</StyledFlexContainer>
							<StyledFlexContainer>
								<NumberInput
									className={'col-3'}
									id="discountPercentage"
									label="% de desconto *"
									maxLength={2}
									{...props}
								/>
								<NumberInput
									className={'col-3'}
									id="couponsAmount"
									label="Quantidade de cupons"
									maxLength={16}
									{...props}
								/>
								<NumberInput
									className={'col-3'}
									id="couponsPerCustomer"
									label="Cupons por usuário *"
									maxLength={6}
									{...props}
								/>
							</StyledFlexContainer>
							<StyledFlexContainer>
								<StyledDocument className="col-3">
									<TextInput
										{...props}
										id="dateStart"
										label="Data de Início *"
										type="date"
									/>
								</StyledDocument>
								<StyledDocument className="col-3">
									<TextInput
										{...props}
										id="dateEnd"
										label="Data de Término *"
										type="date"
									/>
								</StyledDocument>
								<SelectInput
									{...props}
									multi={false}
									label="Tipo *"
									id="couponType"
									className={'col-3'}
									defaultValue={{ value: '', label: '' }}
									onValueChange={value =>
										this.changeCouponType(props, value)
									}
									options={couponConstants.couponTypeOptions}
								/>
								<SelectInput
									{...props}
									disabled={this.state.disablePartner}
									multi={false}
									label="Parceiro"
									id="busCompany"
									className={'col-3'}
									defaultValue={{ value: null, label: 'Todos' }}
									options={couponConstants.couponBusCompanyOptions}
								/>
							</StyledFlexContainer>
							<StyledFlexContainer>
								<SelectInput
									className={'col-3'}
									id="validForRoundTrip"
									label="Válido para ida e volta"
									defaultValue={{ value: '', label: '' }}
									options={tripOptions}
									multi={false}
									{...props}
								/>
								<DatepickerInput
									openDirection={'up'}
									className={'col-3'}
									id="boardingDate"
									label="Data de Embarque Início"
									{...props}
								/>
								<DatepickerInput
									openDirection={'up'}
									className={'col-3'}
									id="boardingDateEnd"
									label="Data de Embarque Fim"
									{...props}
								/>
								<NumberInput
									className={'col-3'}
									id="moveflexNumber"
									label="Cliente (Número Moveflex)"
									maxLength={6}
									{...props}
								/>
							</StyledFlexContainer>
							<StyledFlexContainer>
								<TextInput
									className={'col-6'}
									id="busClasses"
									label="Modalidades"
									placeholder={
										'Insira as modalidades permitidas, separadas por vírgula. Deixe em branco para não aplicar a validação.'
									}
									maxLength={256}
									{...props}
								/>
								<SelectInput
									{...props}
									multi={false}
									label="Método de pagamento *"
									id="paymentMethod"
									className={'col-3'}
									defaultValue={{ value: '', label: '' }}
									options={couponConstants.couponPaymentMethodOptions}
								/>
								<NumberInput
									className={'col-3'}
									id="daysInAdvanceForBoarding"
									label="Dias de Antecedência"
									maxLength={2}
									{...props}
								/>
							</StyledFlexContainer>
							<StyledFlexContainer>
								<SelectInput
									{...props}
									multi={false}
									label="Agência"
									id="agencyFilter"
									className={'col-6'}
									defaultValue={{ value: '', label: '' }}
									options={couponConstants.couponAgencyOptions}
								/>
								<SelectInput
									{...props}
									multi={false}
									label="Plataforma"
									id="salesOriginFilter"
									className={'col-6'}
									defaultValue={{ value: '', label: '' }}
									options={couponConstants.couponPlatformOptions}
								/>
							</StyledFlexContainer>
							<StyledFlexContainer>
								<TextInput
									className={'col-12'}
									id="origins"
									label="Origem"
									style={{ textTransform: 'uppercase' }}
									maxLength={600}
									{...props}
								/>{' '}
							</StyledFlexContainer>
							<StyledFlexContainer>
								<TextInput
									className={'col-12'}
									id="destinations"
									label="Destino"
									style={{ textTransform: 'uppercase' }}
									maxLength={600}
									{...props}
								/>
							</StyledFlexContainer>
							<StyledButtonContainer>
								<Button
									onClick={() =>
										this.props.history.push(
											`${routes.ADMIN}/cupons-de-desconto`
										)
									}
									danger
									style={{ marginRight: '15px' }}
									type="button">
									Cancelar
								</Button>
								<Button primary type="submit">
									Salvar
								</Button>
							</StyledButtonContainer>
						</Form>
					)}
				/>
			</div>
		)
	}
}
const tripOptions = [
	{ value: '', label: '' },
	{ value: 'true', label: 'Sim' },
	{ value: 'false', label: 'Não' }
]

const marginTop = 3.2
const StyledDocument = styled.div`
	.is-client {
		color: ${PRIMARY_LIGHT};
		margin-top: 10px;
		position: absolute;
	}
	@media screen and (max-width: ${breakpoints.IPHONE_SE}px) {
		.is-client {
			margin-top: 3px;
		}
	}
`

export default CreationForm
